var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"IrAOVRechazada"}},[_c('b-button',{attrs:{"variant":"action"},on:{"click":function($event){return _vm.goToRejectedOV()}}},[_vm._v("Revisar OV Rechazada")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }